import { Tab, Tabs } from "@mui/material";
import { FC } from "react";
import { TAB_TYPE, TabStyle } from "../helper";
import { TabWrapper } from "./style";

interface HeaderTabTypes {
  currentTab: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const HeaderTab: FC<HeaderTabTypes> = ({ currentTab, handleChange }) => {
  return (
    <TabWrapper>
      <Tabs value={currentTab} onChange={handleChange} sx={TabStyle}>
        <Tab label="All" value={TAB_TYPE.ALL} />
        <Tab label="Unread" value={TAB_TYPE.UNREAD} />
        <Tab label="Summary" value={TAB_TYPE.SUMMARY} />
      </Tabs>
    </TabWrapper>
  );
};

export default HeaderTab;
